import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number | string
}

export const GooglePerformanceIllustration: FunctionComponent<Props> = ({ size = 45 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 45 45' fill='none'>
      <Path
        d='M22.658 0c-3.106 0-6.12.537-8.957 1.595C6.945 4.118 2.196 9.71.67 16.94c-1.009 4.713-.88 9.073.396 13.322 1.63 5.425 5.628 10.001 10.972 12.553 2.652 1.27 5.7 1.994 9.056 2.153.431.02.87.031 1.305.031 2.693 0 5.402-.372 8.052-1.105.203-.05.397-.104.602-.165 2.381-.702 4.524-1.813 6.358-3.298 1.99-1.602 3.63-3.634 4.866-6.036.243-.473.476-.97.733-1.567 1.414-3.307 2.097-7.01 1.976-10.713-.057-1.636-.298-3.376-.716-5.175-.689-2.92-1.81-5.665-3.246-7.944a22.076 22.076 0 00-1.112-1.588c-2.58-3.353-6.599-5.706-11.62-6.8A26.428 26.428 0 0022.66 0V0z'
        fill='#FFE9E3'
      />
      <Path
        d='M34.054 23.351c0 2.99-1.71 6.59-4.59 9.07-2.03 1.75-4.63 2.95-7.6 2.96-5.19.02-9.02-2.6-10.78-6.05-.44-.86-.75-1.78-.93-2.72-.12-.63-.17-1.27-.15-1.91.08-3.78 1.64-8.21 4.8-11.44a14.553 14.553 0 014.68-3.23c5.77-2.48 13.49-.3 14.38 4.99.47 2.77-5.03 3.14-5.49.39-.54-3.2-6.22-2.07-8.21-.51-.13.1-.26.21-.38.32-.46.39-.88.83-1.27 1.29-1.83 2.18-2.85 5.01-3 7.47 0 .1-.01.21-.02.31-.02.55.03 1.11.15 1.67.53 2.6 2.54 5.04 6.28 5.06 1.96.01 3.22-.96 4.19-2.25.64-.84 1.36-1.83 1.85-2.84-1.17.07-2.35.15-3.53.22-3.54.23-3.85-4.11-.31-4.33 2.34-.15 4.69-.3 7.03-.44 1.42-.09 2.9.79 2.9 1.97z'
        fill='#4285F4'
      />
      <Path
        d='M19.784 15.231c-.46.39-.88.83-1.27 1.29-1.83 2.18-2.85 5.01-3 7.47 0 .1-.01.21-.02.31-.02.55.03 1.11.15 1.67l-4.56 3.35c-.44-.86-.75-1.78-.93-2.72-.12-.63-.17-1.27-.15-1.91.08-3.78 1.64-8.21 4.8-11.44.47-.48.97-.93 1.52-1.36 1.14 1.09 2.36 2.26 3.46 3.32v.02z'
        fill='#FBBC06'
      />
      <Path
        d='M28.384 15.411c-.54-3.2-6.22-2.07-8.21-.51-.13.1-.26.21-.38.32-.46.39-.88.83-1.27 1.29-1.1-.92-2.46-2.15-3.71-3.26a14.553 14.553 0 014.68-3.23c5.77-2.48 13.49-.3 14.38 4.99.47 2.77-5.03 3.14-5.49.39v.01z'
        fill='#EA4335'
      />
      <Path
        d='M29.464 32.421c-2.03 1.75-4.63 2.95-7.6 2.96-5.19.02-9.02-2.6-10.78-6.05-.44-.86-.75-1.78-.93-2.72l5.35-2.61c0 .1-.01.21-.02.31-.02.55.03 1.11.15 1.67.53 2.6 2.54 5.04 6.28 5.06 1.96.01 3.22-.96 4.19-2.25l3.35 3.64.01-.01z'
        fill='#33A853'
      />
    </Svg>
  )
}
